import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AppFrame from "../../Appframe/AppFrame";
import layout from "../../../styles/layout";

import { Paper, Button } from "@material-ui/core";

import ReportingService from "../../../services/reporting";
import Loader from "react-loader-advanced";
import loadingGif from "../../../resources/images/loading.gif";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import colors, { colorsV2 } from "../../../styles/colors";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Title from "../../../components/common/Title";

const OrganizationOverviewReport = (props) => {
  const [reportData, setReportData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const printReport = () => {
    let containerEl = document.createElement("div");
    const input = document.getElementById("reportContainer");
    let inputClone = input.cloneNode(true);
    input.appendChild(inputClone);
    containerEl.appendChild(inputClone);
    let externalWindow = window.open(
      "",
      "",
      "width=1000,height=600,left=200,top=200"
    );

    externalWindow.document.body.appendChild(containerEl);
    //Trigger automatic print and close window after.
    externalWindow.onafterprint = () => {
      externalWindow.close();
    };
    setTimeout(() => {
      externalWindow.print();
    }, 3000);
  };

  const classes = makeStyles({
    table: {
      minWidth: 650,
      borderCollapse: "collapse",
    },
    colHeader: {
      textAlign: "right",
      verticalAlign: "bottom",
      writingMode: "vertical-rl",
      transform: "rotate(180deg)",
    },
  });

  useEffect(() => {
    //Run on load
    if (props.organization && props.organization.orgId) {
    }
  }, [props.organization]);

  const refreshReportData = () => {
    if (startDate != null && endDate != null) {
      setIsLoading(true);
      ReportingService()
        .getChannelOverviewReport(props.organization.orgId, startDate, endDate)
        .then((resp) => {
          setIsLoading(false);
          setReportData(resp.reportData);
        });
    }
  };

  let lastProvider = null;

  const transform = `rotate(${180}deg)`;

  return (
    <AppFrame
      auth={props.auth}
      header="Provider Activity"
      optionsType="organizationReporting"
      whiteLabelSettings={props.whiteLabelSettings}
    >
      <Title text1="" text2="" goBack={() => props.history.goBack()} />
      <Loader message="Generating Report..." show={isLoading} />
      <Paper elevation={5} style={{ padding: 1, margin: 30, marginBottom: 50 }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignContent: "center",
            alignItems: "center",
            justifyContent: "space-evenly",
            height: 60,
            flex: 1,
          }}
        >
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              id="startDate-picker-inline"
              label="Start Date"
              value={startDate}
              onChange={(value) => {
                setStartDate(value);
              }}
              KeyboardButtonProps={{
                "aria-label": "Change Start Date",
              }}
            />
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              id="endDate-picker-inline"
              label="End Date"
              value={endDate}
              onChange={(value) => {
                setEndDate(value);
              }}
              KeyboardButtonProps={{
                "aria-label": "Change End Date",
              }}
            />
          </MuiPickersUtilsProvider>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
        >
          <Button
            onClick={() => refreshReportData()}
            variant="outlined"
            style={{
              margin: 15,
              backgroundColor: colors.accent,
            }}
          >
            {reportData ? "Load Report" : "Refresh Report"}
          </Button>
        </div>
      </Paper>
      {!reportData && !isLoading && (
        <Paper
          style={{
            margin: 30,
            padding: 20,
            borderColor: colorsV2.primary,
            borderWidth: 2,
            borderStyle: "solid",
          }}
          elevation={3}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            Please use the filters above to generate the report.
          </div>
        </Paper>
      )}
      {isLoading && (
        <Paper
          style={{
            margin: 30,
            padding: 20,
            borderColor: colorsV2.primary,
            borderWidth: 2,
            borderStyle: "solid",
          }}
          elevation={3}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div>
              <h1>Generating Report....</h1>
              <p>
                Report may take a few minutes to complete, please be patient.
              </p>
            </div>
            <div>
              <img
                src={loadingGif}
                alt="Loading..."
                style={{ marginLeft: "auto", marginRight: "auto", width: 150 }}
              />
            </div>
          </div>
        </Paper>
      )}
      {reportData && reportData.length > 0 && (
        <Paper
          style={{
            margin: 30,
            padding: 20,
            borderColor: colorsV2.primary,
            borderWidth: 2,
            borderStyle: "solid",
          }}
          elevation={3}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            {true == false && (
              <Button variant="outlined" style={{ marginBottom: 20 }}>
                Print Report
              </Button>
            )}
          </div>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="table">
              <TableHead
                style={{
                  borderBottom: "solid",
                  borderBottomColor: "black",
                }}
              >
                <TableRow>
                  <TableCell colSpan={2}></TableCell>
                  <TableCell
                    colSpan={5}
                    style={{
                      verticalAlign: "bottom",
                      textAlign: "center",
                      margin: 0,
                      cellSpacing: 0,
                      cellPadding: 0,
                      border: "solid 2px black",
                      padding: 5,
                      backgroundColor: colors.accent,
                    }}
                  >
                    Provider Stats
                  </TableCell>
                  <TableCell
                    colSpan={3}
                    style={{
                      verticalAlign: "bottom",
                      textAlign: "center",
                      margin: 0,
                      cellSpacing: 0,
                      cellPadding: 0,
                      border: "solid 2px black",
                      padding: 5,
                      backgroundColor: colors.primary,
                    }}
                  >
                    Patient Stats
                  </TableCell>
                  <TableCell
                    colSpan={3}
                    style={{
                      verticalAlign: "bottom",
                      textAlign: "center",
                      margin: 0,
                      cellSpacing: 0,
                      cellPadding: 0,
                      border: "solid 2px black",
                      padding: 5,
                      backgroundColor: "#",
                    }}
                  >
                    Channel Stats
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    style={{
                      verticalAlign: "bottom",
                    }}
                  >
                    Provider
                  </TableCell>
                  <TableCell
                    align="right"
                    style={{
                      verticalAlign: "bottom",
                    }}
                  >
                    Channel Name
                  </TableCell>

                  <TableCell
                    align="left"
                    style={{
                      verticalAlign: "bottom",
                      writingMode: "vertical-rl",
                      backgroundColor: colors.accent,
                      cellSpacing: 0,
                      cellPadding: 0,
                      border: "solid 2px black",
                      padding: 5,
                    }}
                  >
                    New Patients Added
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      verticalAlign: "bottom",
                      writingMode: "vertical-rl",
                      backgroundColor: colors.accent,
                      cellSpacing: 0,
                      cellPadding: 0,
                      border: "solid 2px black",
                      padding: 5,
                    }}
                  >
                    Care Plans Reviewed
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      verticalAlign: "bottom",
                      writingMode: "vertical-rl",
                      backgroundColor: colors.accent,
                      cellSpacing: 0,
                      cellPadding: 0,
                      border: "solid 2px black",
                      padding: 5,
                    }}
                  >
                    Instructions Prescribed
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      verticalAlign: "bottom",
                      writingMode: "vertical-rl",
                      backgroundColor: colors.accent,
                      cellSpacing: 0,
                      cellPadding: 0,
                      border: "solid 2px black",
                      padding: 5,
                    }}
                  >
                    RTM Interactions Logged
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      verticalAlign: "bottom",
                      writingMode: "vertical-rl",
                      backgroundColor: colors.accent,
                      cellSpacing: 0,
                      cellPadding: 0,
                      border: "solid 2px black",
                      padding: 5,
                    }}
                  >
                    Messages Sent To Patients
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      verticalAlign: "bottom",
                      writingMode: "vertical-rl",
                      backgroundColor: colors.primary,
                      cellSpacing: 0,
                      cellPadding: 0,
                      border: "solid 2px black",
                      padding: 5,
                    }}
                  >
                    Active Patients
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      verticalAlign: "bottom",
                      writingMode: "vertical-rl",
                      backgroundColor: colors.primary,
                      cellSpacing: 0,
                      cellPadding: 0,
                      border: "solid 2px black",
                      padding: 5,
                    }}
                  >
                    Patient Activities
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      verticalAlign: "bottom",
                      writingMode: "vertical-rl",
                      backgroundColor: colors.primary,
                      cellSpacing: 0,
                      cellPadding: 0,
                      border: "solid 2px black",
                      padding: 5,
                    }}
                  >
                    Messages Viewed
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      verticalAlign: "bottom",
                      writingMode: "vertical-rl",
                      backgroundColor: "#F2F2F2",
                      cellSpacing: 0,
                      cellPadding: 0,
                      border: "solid 2px black",
                      padding: 5,
                    }}
                  >
                    Current Active Patients
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      verticalAlign: "bottom",
                      writingMode: "vertical-rl",
                      backgroundColor: "#F2F2F2",
                      cellSpacing: 0,
                      cellPadding: 0,
                      border: "solid 2px black",
                      padding: 5,
                    }}
                  >
                    Total Patients Discharged
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      verticalAlign: "bottom",
                      writingMode: "vertical-rl",
                      backgroundColor: "#F2F2F2",
                      cellSpacing: 0,
                      cellPadding: 0,
                      border: "solid 2px black",
                      padding: 5,
                    }}
                  >
                    Total Patients Removed
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reportData != null &&
                  reportData.map((row) => {
                    let providerName = "";
                    let providerStatus = "";
                    //Only display the provider name once
                    if (lastProvider !== row.userId) {
                      lastProvider = row.userId;
                      providerName =
                        row.providerFirstName + " " + row.providerLastName;
                      providerStatus = String(!row.providerDisabled);
                    }
                    return (
                      <TableRow key={row.name}>
                        <TableCell component="th" scope="row">
                          {providerName}
                        </TableCell>
                        <TableCell align="right">{row.appName}</TableCell>
                        {
                          //PROVIDER METRICS
                        }
                        <TableCell
                          align="right"
                          style={{ borderLeft: "2px black solid" }}
                        >
                          {row.newPatients}
                        </TableCell>
                        <TableCell align="right">
                          {row.carePlansReviewed}
                        </TableCell>
                        <TableCell align="right">{row.instructionRx}</TableCell>
                        <TableCell align="right">
                          {row.loggedInteractions}
                        </TableCell>
                        <TableCell align="right">{row.messagesSent}</TableCell>
                        {
                          //Patient METRICS
                        }
                        <TableCell
                          align="right"
                          style={{ borderLeft: "2px black solid" }}
                        >
                          {row.activePatients}
                        </TableCell>
                        <TableCell align="right">
                          {row.patientActivities}
                        </TableCell>
                        <TableCell align="right">
                          {row.patientMessageViews}
                        </TableCell>
                        {
                          //Channel Stats
                        }
                        <TableCell
                          align="right"
                          style={{ borderLeft: "2px black solid" }}
                        >
                          {row.active}
                        </TableCell>
                        <TableCell align="right">{row.discharged}</TableCell>
                        <TableCell align="right">{row.removed}</TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}
    </AppFrame>
  );
};

function mapStateToProps({ user, organization, whiteLabelSettings }, props) {
  return { user, organization, whiteLabelSettings, ...props };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, null)(OrganizationOverviewReport);



// WEBPACK FOOTER //
// ./src/layout/reporting/OrgReporting/OrganizationOverviewReport.js